import React from 'react';

import { usePromiseTracker } from 'react-promise-tracker';

import PropTypes from 'prop-types';

import FadeLoader from 'react-spinners/FadeLoader';

import { makeStyles } from '@material-ui/core/styles';

import { Dialog } from '@material-ui/core';

import '../App.css';

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		margin: '0 auto',
		justifyContent: 'center',
	},
	spinnerContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		margin: '0 auto',
		height: '100px',
		width: '150px',
	},
}));

interface IProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	spinnerRef: React.RefObject<any>;
}

function Spinner(props: IProps): JSX.Element {
	const classes = useStyles();
	const { promiseInProgress } = usePromiseTracker();

	return (
		<div className={classes.root}>
			{promiseInProgress === true ? (
				<Dialog open={promiseInProgress}>
					<div className={classes.spinnerContainer}>
						<FadeLoader ref={props.spinnerRef} color={'#000352'} />
					</div>
				</Dialog>
			) : null}
		</div>
	);
}

Spinner.propTypes = {
	spinnerRef: PropTypes.object,
};

export default Spinner;
